import React, {useState} from 'react';
import _ from 'lodash';

import {Form, Button, Loader, Modal, Popup} from '@components';
import {Props} from './types';
import paths from '@paths';
import utils from '@utils';
import * as hooks from './hooks';
import * as handlers from './handlers';
import mappings from '@mappings';
import resources from '@resources';
import constants from '@constants';

import './index.scss';

const Main: React.FC<Props> = props => {
  const [cardInfo, setCardInfo] = useState<any>({last4: ''});
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);

  hooks.useMount(props.me, setCardInfo, setLoading);

  const getCardElement = () => {
    if (loading) {
      // ローディング中
      return (
        <div className="b__no-card-number">
          <Loader inline active={loading} />
        </div>
      );
    } else if (props.me.customerId !== '' && cardInfo.last4) {
      // カスタマーが存在 && カードも存在
      return (
        <>
          <Form.Label text="カード番号" />
          <div className="b__card-number">{`XXXX XXXX XXXX ${cardInfo.last4}`}</div>
        </>
      );
    } else {
      // カスタマーが存在しない or カスタマーは存在するがカードがない
      return <div className="b__no-card-number">なし</div>;
    }
  };

  const initialValues = {
    lastName: props.me.lastName,
    firstName: props.me.firstName,
    lastKana: props.me.lastKana,
    firstKana: props.me.firstKana,
    email: props.me.email || '-',
    phoneNumber: props.me.phoneNumber || '-',
    prefecture: props.me.prefecture,
    authLevel: props.me.authLevel,
    plan: utils.mappings.getLabel(mappings.plan, props.me.plan),
    position: props.me.position || '-',
    organization: props.me.organization || '-',
    gender:
      _.isNull(props.me.gender) ||
      props.me.gender === constants.USERS.NOT_SELECTED_GENDER
        ? ''
        : props.me.gender,
    birthyear: resources.users.getBirthValue('year', props.me.birthdate),
    birthmonth: resources.users.getBirthValue('month', props.me.birthdate),
    birthday: resources.users.getBirthValue('day', props.me.birthdate),
  };

  return (
    <div className="a__mypage">
      <div className="b__title">マイページ</div>
      <div className="b__main">
        <div className="w__information">
          <Form.User
            isOption
            detail
            handleSubmit={() => {}}
            initialValues={initialValues}
            me={props.me}
            users={props.users}
            submitText=""
            myPage
          />
          {props.me.authLevel === constants.AUTHORITIES.SUPER_ADMIN && (
            <div className="w__credit-card">
              <div className="w__credit-field">
                <div className="b__field-title">保存済みクレジットカード</div>
                {getCardElement()}
                <div className="w__button">
                  <Button.Normal
                    text={
                      !cardInfo.last4
                        ? '新しいクレジットカードを登録する'
                        : 'クレジットカード情報を変更する'
                    }
                    color="green"
                    className="b__edit"
                    onClick={() => {
                      props.history.push(paths.myPage.card);
                    }}
                    disabled={
                      props.me.authLevel !== constants.AUTHORITIES.SUPER_ADMIN
                    }
                  />
                  {props.me.customerId !== '' && cardInfo.last4 ? (
                    <div className="w__delete-button">
                      <Button.Normal
                        text="クレジットカードを削除する"
                        color="red"
                        className="b__edit delete"
                        onClick={() => {
                          setIsDeleteModal(true);
                        }}
                        // NOTE: 契約中のプランがある場合にはカードの削除が出来ない
                        disabled={
                          !!props.me.plan ||
                          props.me.authLevel !==
                            constants.AUTHORITIES.SUPER_ADMIN ||
                          loading
                        }
                      />
                      {!!props.me.plan && (
                        <Popup.Normal content="プラン契約中のため、クレジットカードの削除はできません。" />
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="w__side-buttons">
          <Button.Normal
            text="情報を変更する"
            color="yellow"
            className="b__edit"
            onClick={() => {
              props.history.push(paths.myPage.edit);
            }}
          />
        </div>
      </div>
      <Modal.Delete
        isModal={isDeleteModal}
        handleCloseModal={setIsDeleteModal}
        title="クレジットカードを削除"
        message="クレジットカードを削除しますか？"
        onClick={async () => {
          await handlers.deleteCard(
            props,
            setIsDeleteModal,
            setDeleteLoading,
            setCardInfo
          );
        }}
        loading={deleteLoading}
        disabled={deleteLoading}
      />
    </div>
  );
};

export default Main;
